/* CRE62: approved product films, preserving CRE43 variant image sequences. */
if (!customElements.get('cre62-gallery')) {
  customElements.define('cre62-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.map = JSON.parse(this.querySelector('[data-cre43-map]').textContent);
      this.film = JSON.parse(this.querySelector('[data-cre62-video]').textContent);
      this.screen = window.matchMedia('(max-width: 767px)');
      this.screen.addEventListener('change', () => {
        if (this.sequence?.[this.index]?.video) this.activate(this.index);
      }, options);
      this.content = this.querySelector('[data-cre43-content]');
      this.fallback = this.querySelector('[data-cre43-fallback]');
      this.dialog = this.querySelector('dialog');
      this.dialog?.remove();
      this.content.addEventListener('click', event => {
        const thumb = event.target.closest('[data-index]');
        if (thumb) {
          event.preventDefault();
          this.activate(Number(thumb.dataset.index));

        }
      }, options);
      this.content.addEventListener('keydown', event => {
        if (event.target.closest('video')) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let index = this.index + (event.key === 'ArrowRight' ? 1 : -1);
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = this.sequence.length - 1;
        this.activate(Math.max(0, Math.min(this.sequence.length - 1, index)));
        this.content.querySelector(`[data-index="${this.index}"]`).focus({ preventScroll: true });
      }, options);
      this.content.addEventListener('touchstart', event => {
        this.touch = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { ...options, passive: true });
      this.content.addEventListener('touchend', event => {
        if (event.target.closest('video')) { this.touch = null; return; }
        if (!this.touch || !event.target.closest('.cre43-gallery__hero')) return;
        const dx = this.touch.x - event.changedTouches[0].clientX;
        const dy = this.touch.y - event.changedTouches[0].clientY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          this.activate(Math.max(0, Math.min(this.sequence.length - 1, this.index + (dx > 0 ? 1 : -1))));
        }
        this.touch = null;
      }, { ...options, passive: true });
      document.addEventListener('cre43:variant-change', event => this.select(event.detail.variant), options);
      const boot = () => {
        const buyBox = this.closest('wacc-pdp-buy-box');
        const product = JSON.parse((buyBox?.querySelector('[data-product-json]') || document.getElementById('wacc-product-json')).textContent);
        const id = buyBox?.querySelector('[data-variant-id]')?.value || document.getElementById('wacc-variant-id')?.value || this.dataset.currentVariant;
        this.select(product.variants.find(variant => String(variant.id) === String(id)));
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { ...options, once: true });
      else boot();
    }

    disconnectedCallback() {
      this.content?.querySelector('video')?.pause();
      this.controller?.abort();
      this.controller = null;
    }

    image(item, thumbnail) {
      const image = document.createElement('img');
      image.src = `${item.src}&width=${thumbnail ? 120 : 1400}`;
      image.alt = item.alt;
      image.width = 1000;
      image.height = 1000;
      image.loading = thumbnail ? 'lazy' : 'eager';
      image.decoding = 'async';
      if (!thumbnail) {
        image.srcset = [390, 600, 900, 1200, 1400].map(width => `${item.src}&width=${width} ${width}w`).join(', ');
        image.sizes = '(max-width: 767px) 100vw, (min-width: 1320px) 650px, 50vw';
      }
      return image;
    }

    select(variant) {
      if (!variant) return;
      this.content.querySelector('video')?.pause();
      const changed = String(this.dataset.currentVariant) !== String(variant.id);
      this.dataset.currentVariant = variant.id;
      this.sequence = this.map[String(variant.id)]?.slice();
      if (this.sequence) this.sequence.splice(1, 0, {
        video: true, src: this.film.square.url, role: 'Watch video',
        alt: this.film.title + ' — product video'
      });
      this.content.hidden = !this.sequence;
      this.fallback.hidden = Boolean(this.sequence);
      
      if (!this.sequence) {
        // Preserve the original bundle media and its existing theme controls.
        const filename = variant.featured_image?.src.split('?')[0].split('/').pop();
        const slides = [...this.fallback.querySelectorAll('.wacc-gallery__slide')];
        const index = filename ? slides.findIndex(slide => slide.querySelector('img')?.src.includes(filename)) : 0;
        this.fallback.querySelectorAll('.wacc-gallery__thumb')[Math.max(0, index)]?.click();
        return;
      }
      // Keep the matching server-rendered gallery stable during startup.
      if (!changed && this.content.querySelector('.cre43-gallery__hero') &&
          this.content.querySelectorAll('.cre43-gallery__thumb').length === this.sequence.length) {
        this.index ??= 0;
        return;
      }
      const hero = document.createElement('a');
      hero.className = 'cre43-gallery__hero';
      hero.setAttribute('aria-label', 'Enlarge product image');
      const nav = document.createElement('nav');
      nav.className = 'cre43-gallery__thumbs';
      nav.setAttribute('aria-label', 'Product images');
      this.sequence.forEach((item, index) => {
        const thumb = document.createElement('a');
        thumb.className = 'cre43-gallery__thumb';
        thumb.dataset.index = index;
        thumb.href = item.src;
        thumb.setAttribute('aria-label', item.role);
        if (item.video) {
          thumb.classList.add('cre62-gallery__film-thumb');
          const poster = document.createElement('img');
          poster.src = this.film.square.poster;
          poster.alt = ''; poster.width = 1000; poster.height = 1000; poster.loading = 'lazy';
          const play = document.createElement('span');
          play.textContent = '▶'; play.setAttribute('aria-hidden', 'true');
          thumb.append(poster, play);
        } else thumb.append(this.image(item, true));
        nav.append(thumb);
      });
      const caption = document.createElement('p');
      caption.className = 'cre43-gallery__caption';
      caption.setAttribute('aria-live', 'polite');
      this.content.replaceChildren(hero, nav, caption);
      this.activate(0);
    }

    activate(index) {
      this.index = index;
      const item = this.sequence[index];
      const oldHero = this.content.querySelector('.cre43-gallery__hero');
      oldHero.querySelector('video')?.pause();
      const hero = document.createElement(item.video ? 'div' : 'a');
      hero.className = 'cre43-gallery__hero';
      if (item.video) {
        hero.classList.add('cre62-gallery__film');
        const source = this.screen.matches ? this.film.mobile : this.film.square;
        const video = document.createElement('video');
        video.controls = true; video.playsInline = true; video.preload = 'metadata';
        video.src = source.url; video.poster = source.poster;
        video.width = source.width; video.height = source.height;
        video.setAttribute('aria-label', item.alt);
        hero.append(video);
      } else {
        hero.href = item.src;
        hero.setAttribute('aria-label', 'Enlarge product image');
        hero.append(this.image(item, false));
      }
      oldHero.replaceWith(hero);
      this.content.querySelectorAll('[data-index]').forEach(thumb => {
        thumb.setAttribute('aria-current', String(Number(thumb.dataset.index) === index));
      });
      this.content.querySelector('.cre43-gallery__caption').textContent = `${index + 1} of ${this.sequence.length} - ${item.alt}`;
      const nav = this.content.querySelector('.cre43-gallery__thumbs');
      const thumb = nav.querySelector(`[data-index="${index}"]`);
      const left = thumb.getBoundingClientRect().left - nav.getBoundingClientRect().left + nav.scrollLeft;
      if (left < nav.scrollLeft) nav.scrollLeft = left;
      else if (left + thumb.offsetWidth > nav.scrollLeft + nav.clientWidth) nav.scrollLeft = left + thumb.offsetWidth - nav.clientWidth;
    }
  });
}
